import * as types from '@/store/mutation-types'

export default function({ from, store: { commit } }) {
  if (process.client && from) {
    commit(`one-trust/${types.REMOVE_LOCAL_HANDLERS_ON_ROUTE_CHANGE}`)
  }
}
